import { render } from "./Help.vue?vue&type=template&id=c2027ce4&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import "@/assets/css/footer/help.css?vue&type=style&index=0&id=c2027ce4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\marlo\\Desktop\\spanish-ova-oficial\\OVA-Code-Spanish-main\\New code\\ova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2027ce4"]])

export default __exports__